import script from "./ImageTool.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageTool.vue?vue&type=script&setup=true&lang=ts"

import "./ImageTool.vue?vue&type=style&index=0&id=7a9fd752&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9fd752"]])

export default __exports__